import Vue from 'vue'
import Vuex from 'vuex'
import Auth from '@/services/authenticationService'

import User from '@/store/user'
import Allocations from '@/store/pageStores/allocations'
import Dockets from '@/store/pageStores/dockets'
import Trips from '@/store/pageStores/trips'
import Rctis from '@/store/pageStores/rctis'
import Bills from '@/store/pageStores/bills'
import Drivers from '@/store/pageStores/drivers'
import Tips from '@/store/pageStores/tips'
import TipSpoils from '@/store/pageStores/tipSpoils'
import Sites from '@/store/pageStores/sites'
import Clients from '@/store/pageStores/clients'
import Spoils from '@/store/pageStores/spoils'
import Projects from '@/store/pageStores/projects'
import Contractors from '@/store/pageStores/contractors'
import Global from '@/store/global'
import Vehicles from '@/store/pageStores/vehicles'
import VehicleTypes from '@/store/pageStores/vehicleTypes'
import Rates from '@/store/pageStores/rates'
import BatchAllocations from '@/modules/batchAllocations/store/batchAllocations'
import AllocationStaging from '@/modules/batchAllocations/staging/store/allocationStaging'
import Users from '@/store/pageStores/users'
import Shared from '@/store/shared'
import Tipping from '@/modules/tipping/store/tipping'
import Compliance from '@/modules/complianceResources/store/compliance'
import Audits from '@/modules/audits/store/audits'
import Settings from '@/modules/settings/store/settings'
import ApprovedBillLines from '@/modules/approvedBillLines/store/approvedBillLines'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    global: Global,
    user: User,
    allocations: Allocations,
    dockets: Dockets,
    trips: Trips,
    rctis: Rctis,
    bills: Bills,
    drivers: Drivers,
    sites: Sites,
    clients: Clients,
    projects: Projects,
    spoils: Spoils,
    contractors: Contractors,
    tips: Tips,
    tipSpoils: TipSpoils,
    rates: Rates,
    vehicles: Vehicles,
    vehicleTypes: VehicleTypes,
    shared: Shared,
    users: Users,
    batchAllocations: BatchAllocations,
    allocationStaging: AllocationStaging,
    tipping: Tipping,
    compliance: Compliance,
    audits: Audits,
    settings: Settings,
    approvedBillLines: ApprovedBillLines
    // dockets: {

    // },
    // global: {

    // },
    // notifications: {

    // }
  }
})
